import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress'
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { Redirect, useLocation } from 'react-router-dom';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useInput } from "../utils/useInputHook";
import { useAlert } from "react-alert";
import { Paper, FormControl, IconButton, InputAdornment, OutlinedInput, InputLabel } from '@material-ui/core';
import { resetPassword } from '../api/auth';

const useStyles = makeStyles((theme) => ({
    wrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
    },
    paper: {
        padding: theme.spacing(2, 4),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '500px',
    },
    avatar: {
        margin: theme.spacing(5, 1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export default function UpdatePasswordPage() {
    const classes = useStyles();
    const alert = useAlert();
    const queryParams = useQuery();
    const resetToken = queryParams.get('token');

    const [loading, setLoading] = useState(false);
    const { value: password, bind: bindPassword } = useInput('');
    const [isSuccess, setIsSuccess] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const { value: passwordConfirm, bind: bindPasswordConfirm } = useInput('');

    if (!resetToken) {
        // no resetToken in URL, redirect to home
        return (<Redirect to="/login" />);
    }

    const handleUpdate = async (e) => {
        e.preventDefault();

        if (!password || !passwordConfirm) {
            alert.show("Password cannot be empty");
            return;
        }
        if (password !== passwordConfirm) {
            alert.show("Pasword and confirm password should match");
            return;
        }
        try {
            setLoading(true);
            const res = await resetPassword({ resetToken, password });
            alert.show(res.message)
        } catch (error) {
            alert.show(error.toString())
        } finally {
            setLoading(false)
            setIsSuccess(true);
        }
    }


    if (isSuccess) {
        return (<Redirect to="/login" />);
    }

    return (
        <Container component="main" maxWidth="xs" className={classes.wrapper}>
            <Paper className={classes.paper} elevation={4}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Update password
                </Typography>
                <form className={classes.form} onSubmit={handleUpdate} noValidate>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel htmlFor="password">Password</InputLabel>
                                <OutlinedInput
                                    variant="outlined"
                                    required
                                    disabled={loading}
                                    fullWidth
                                    {...bindPassword}
                                    name="password"
                                    label="Password"
                                    type={showPassword ? 'text' : 'password'}
                                    id="password"
                                    autoComplete="current-password"
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={() => setShowPassword(s => !s)}
                                            >
                                                {showPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="password-confirm"
                                type="password"
                                disabled={loading}
                                label="Confirm Password"
                                name="password-confirm"
                                {...bindPasswordConfirm}
                            />
                        </Grid>
                    </Grid>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        {loading ? <CircularProgress color="inherit" className={classes.circularProgress} size={20} /> : 'Update password'}
                    </Button>
                </form>
            </Paper>
        </Container>
    );
}
